require('./RAInvestmentHorizonInput.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
// @ components
const RAInput = require('../RAInput/RAInput');
// @ utilities
import { FormattedText } from 'core/i18n';
// @ constants
const {
    RA_INVESTMENT_HORIZON_INPUT_MIN,
    RA_INVESTMENT_HORIZON_INPUT_MAX,
    RA_INVESTMENT_HORIZON_MAX_NON_MASKED_INPUT_VALUE,
} = require('../../../../constants/RAConstants');

class RAInvestmentHorizonInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isInputFocused: false,
        };

        this.handleChangeValue = this.handleChangeValue.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
    }

    handleFocus(e) {
        if (e.target.nodeName === 'INPUT') {
            this.setState({ isInputFocused: true });
            this.props.recordEventInputClick();
        }
    }

    handleBlur() {
        this.setState({ isInputFocused: false });
    }

    mapInput(value) {
        // Don't mask the input if the user is changing the value by checking this.state.isInputFocused
        if (!this.state.isInputFocused && value > RA_INVESTMENT_HORIZON_MAX_NON_MASKED_INPUT_VALUE) {
            value = RA_INVESTMENT_HORIZON_MAX_NON_MASKED_INPUT_VALUE;
        }
        return value;
    }

    handleChangeValue(evt) {
        this.handleBlur();
        this.props.updateInvestmentHorizonSlider(evt);
    }

    render() {
        const { value, disabled } = this.props;
        const inputValue = this.mapInput(value);
        // We need to check against the real value and not the mapped value
        const isBiggerThanMax = value > RA_INVESTMENT_HORIZON_MAX_NON_MASKED_INPUT_VALUE;
        const containerClassName = classNames('ra-investment-horizon-input', {
            'ra-investment-horizon-input--is-disabled': !!disabled,
        });
        const inputClassName = classNames('ra-investment-horizon-input__input', {
            'ra-investment-horizon-input__plus-label': !this.state.isInputFocused && isBiggerThanMax,
        });

        return (
            <div className={containerClassName}>
                <div className="ra-investment-horizon-input__term-number" onFocus={this.handleFocus}>
                    <RAInput
                        amount={inputValue}
                        disabled={disabled}
                        customClassName={inputClassName}
                        onChange={this.handleChangeValue}
                        showBlurZero={true}
                        min={RA_INVESTMENT_HORIZON_INPUT_MIN}
                        max={RA_INVESTMENT_HORIZON_INPUT_MAX}
                    />
                </div>
                <div className="ra-investment-horizon-input__term-unit">
                    <FormattedText value="raInvestmentHorizonInput-raInvestmentHorizonInput_years" />
                </div>
            </div>
        );
    }
}

RAInvestmentHorizonInput.propTypes = {
    disabled: PropTypes.bool,
    updateInvestmentHorizonSlider: PropTypes.func.isRequired,
    value: PropTypes.number.isRequired,
};

module.exports = RAInvestmentHorizonInput;
